import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesCustomFieldsConfigRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-custom-fields-config',
	path: '/secure/admin/ConfigureCustomField!default.jspa',
};
